module.exports = __webpack_public_path__ + "static/media/apply_client_demo.9fabfafa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/apply_client_demo.svg
// module id = 480
// module chunks = 0